import Player from "@vimeo/player";

$(function () {
  let $videos = $('.inline-video');
  if (!!$videos.length) {	
		[...$videos].forEach(v => {
			if (!!v.querySelector("img")) v.classList.add("inline-video--has-img");
		});
    $videos.click(function () {
      $(this).addClass('is-active');
      let $iframe = $(this).find('iframe');
			if ($iframe.attr("src").includes("youtube")) {
				$iframe.attr('src', $iframe.attr('src') + '?autoplay=1');
			} else if ($iframe.attr("src").includes("vimeo")) {
				let player = new Player($iframe);
				player.play();
			}
    });
  }
});
